import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import styles from './EmissorOrderBeneficiaryTooltip.module.css';
function formatValue(value) {
    const trimmed = value?.trim() ?? '';
    return trimmed.length > 0 ? trimmed : '-';
}
export function EmissorOrderBeneficiaryTooltip({ beneficiary, testIdIdentifier = 'EmissorOrderBeneficiaryTooltip', }) {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const hideTimeoutRef = useRef(null);
    useEffect(() => {
        return () => {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
            }
        };
    }, []);
    const showTooltip = useCallback(() => {
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
        }
        setIsVisible(true);
    }, []);
    const hideTooltip = useCallback(() => {
        setIsVisible(false);
    }, []);
    const handleMouseLeave = useCallback(() => {
        hideTimeoutRef.current = setTimeout(() => {
            setIsVisible(false);
            hideTimeoutRef.current = null;
        }, 300);
    }, []);
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (!isVisible) {
                showTooltip();
            }
        }
        else if (event.key === 'Escape' && isVisible) {
            event.preventDefault();
            hideTooltip();
        }
    }, [hideTooltip, isVisible, showTooltip]);
    return (_jsxs("span", { className: styles.wrapper, children: [_jsx("button", { type: 'button', className: styles.iconTrigger, "data-testid": `view${testIdIdentifier}IconTrigger`, "aria-label": t('beneficiary.details.information'), "aria-expanded": isVisible, onMouseEnter: showTooltip, onMouseLeave: handleMouseLeave, onClick: () => {
                    if (!isVisible) {
                        showTooltip();
                    }
                }, onKeyDown: handleKeyDown, children: _jsx(Icon, { name: 'actionInformationDark', width: 16, height: 16 }) }), isVisible && (_jsx("div", { className: styles.tooltip, "data-testid": `view${testIdIdentifier}Content`, role: 'tooltip', onMouseEnter: () => {
                    if (hideTimeoutRef.current) {
                        clearTimeout(hideTimeoutRef.current);
                        hideTimeoutRef.current = null;
                    }
                }, onMouseLeave: handleMouseLeave, children: _jsxs("div", { className: styles.tooltipContent, children: [_jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}Admission`, children: [t('beneficiary.details.admission'), ": -"] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}ContractType`, children: [t('beneficiary.details.contractType'), ": ", formatValue(beneficiary.contractType)] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}JobRole`, children: [t('beneficiary.details.jobRole'), ": ", formatValue(beneficiary.jobRole)] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}CostCenter`, children: [t('beneficiary.details.costCenter'), ": -"] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}Department`, children: [t('beneficiary.details.department'), ": -"] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}Category`, children: [t('beneficiary.details.category'), ": -"] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}EmploymentBond`, children: [t('beneficiary.details.employmentBond'), ": -"] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}Branch`, children: [t('beneficiary.details.branch'), ": -"] }), _jsxs("div", { className: styles.tooltipRow, "data-testid": `textView${testIdIdentifier}Union`, children: [t('beneficiary.details.union'), ": -"] })] }) }))] }));
}
